import React from 'react';

import { PatternFormat, PatternFormatProps } from 'react-number-format';

import { StyledInput, StyledInputProps } from '@components/common/StyledInput/StyledInput';

type MaskedInputProps = PatternFormatProps<StyledInputProps>;

export const MaskedPatternInput = React.forwardRef<HTMLInputElement, MaskedInputProps>(
    (props, ref) => {
        return <PatternFormat customInput={StyledInput} getInputRef={ref} {...props} />;
    },
);
